import HeaderWithData from "./HeaderWithData";

export default HeaderWithData;
